var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"chatContainer"},[_c('v-row',[_c('HeaderChat')],1),_c('v-row',{staticClass:"ma-0 pa-0"},[_c('CommentChat')],1),_c('v-row',{staticClass:"ma-0 pa-0"},[_c('FooterChat')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }